import apiClient from '@/api/client';

// ─── Die Gemeinschaft ────────────────────────────────────────────────────────
//
// Das Forum ist keine Seite dieser Anwendung mehr, sondern eine eigene unter
// community.<domain>. Von hier bleibt genau eine Frage übrig: Soll der Weg
// dorthin überhaupt gezeigt werden?
//
// Denn das Forum ist abschaltbar und hängt am Tarif des KONTOS. Ein Link, der
// zu „Das Forum ist in deinem Tarif nicht enthalten" führt, wäre schlechter als
// gar keiner – deshalb fragt die Anwendung vorher.
//
// Bewusst nur dieses eine Feld: Themen, Beiträge und Anhänge werden hier nicht
// mehr geladen. Sie gehören in die andere Anwendung, und dass diese Datei sie
// nicht kennt, ist die Zusage.

export interface Gemeinschaftszugang {
  lesen: boolean;
}

export async function ladeGemeinschaftszugang(): Promise<Gemeinschaftszugang> {
  const { data } = await apiClient.get<Gemeinschaftszugang>('/forum/zugang');
  return { lesen: data.lesen === true };
}

/**
 * Adresse der Gemeinschaft. Zur Bauzeit gesetzt; leer heißt: kein Link.
 *
 * Lieber kein Verweis als einer ins Leere. Wer die Variable beim Bauen
 * vergisst, bekommt kein kaputtes Ziel, sondern gar keins.
 */
export const COMMUNITY_URL: string = import.meta.env.VITE_COMMUNITY_URL ?? '';
